// export const requiredHeaders = [
//   'pickup_street','pickup_city','pickup_state','pickup_zipcode',
//   'dropoff_street','dropoff_city','dropoff_state','dropoff_zipcode',
//   'customer_name',
// ];

// export const multiNameRequiredHeaders = [
//   ['dropoff_earliest_datetime','dropoff_earliest_ts'],
//   ['dropoff_latest_datetime','dropoff_latest_ts'],
// ]

export const requiredHeaders = [
];

export const multiNameRequiredHeaders = [
]